import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FolderService } from '@app/services/folder.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { SidebarService } from '@services/sidebar.service';
import { MatTableDataSource } from '@angular/material';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FolderNode } from '@app/models/view-models/folder';

@Component({
  selector: 'folder-move',
  templateUrl: './folder-move.component.html',
  styleUrls: ['./folder-move.component.scss'],
  providers: [SidebarService],
})

export class FolderMoveComponent extends BaseComponent implements OnInit {
  public folderFormGroup: FormGroup;
  public dataLoaded = false;
  public dsDocument: any = [];
  public treeControl: FlatTreeControl<any>;
  public treeFlattener: MatTreeFlattener<any, any>;
  public matTreeDataSource: MatTreeFlatDataSource<any, any>;
  private id: null;
  constructor(
    public activatedRoute: ActivatedRoute,
    public folderService: FolderService,
    public sidebarService: SidebarService,
    public state: State,
    private formBuilder: FormBuilder
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService: sidebarService,
      state: state,
      modelService: folderService,
    });

    this.setPageVars({
      sidebar: 'folders',
    });
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<any>(this.getLevel, this.isExpandable);
    this.matTreeDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }

  ngOnInit(): void {
    this.initialFormGroup();
    const id = this.routeParams['id'];
    this.modelService.getAll().subscribe((result) => {
      if (result.data !== undefined) {
        const row = result.data.find((r) => r.uuid === id);
        if (row !== undefined) {
          this.dsDocument = new MatTableDataSource<any>(row.documents);
          this.folderFormGroup.patchValue(row);
        }
        this.dataLoaded = true;
        // exclude the current selected folder row from the target list.
        this.matTreeDataSource.data = this.excludeCurrentRow(result.data, id) as any;
      }
    });
  }

  get controls(): any {
    return this.folderFormGroup.controls;
  }

  public cancel(): void {
    this.folderFormGroup.reset();
  }

  public save(): void {
    console.log(this.folderFormGroup.value);
    this.folderService.patchById(this.routeParams['id'], this.folderFormGroup.value).subscribe((result) => this.SavedMessage(result));
  }

  public transformer(node: any, level: number) {
    return {
      name: node.name,
      level: level,
      expandable: !!node.sub_folders,
      uuid: node.uuid,
    };
  }

  public getLevel(node: FolderNode) {
    return node.level;
  }

  public isExpandable(node: FolderNode) {
    return node.expandable;
  }

  public getChildren(node: FolderNode) {
    return observableOf(node.sub_folders);
  }

  public hasChild(index: number, node: FolderNode) {
    return node.expandable;
  }

  public selectedTargetFolder(event): void {
    this.folderFormGroup.patchValue({
      'parent_folder_uuid': event.uuid
    });
  }

  private SavedMessage(data): void {
    this.state.message({ ['FolderIndexUpdate']: true });
    this.closeSlideout();
  }

  public closeSlideout(): void {
    this.state.message({ slideoutHide: true });
  }

  private initialFormGroup(): void {
    this.folderFormGroup = this.formBuilder.group({
      parent_folder_uuid: [null],
    });
  }

  private excludeCurrentRow(data, uuid) {
    for (let i = 0 ; i <= data.length - 1; i++) {
        if (data[i].uuid === uuid) {
            data.splice(i, 1);
        }
    }
    return data;
  }
}
